<template>
  <b-table
    :data="tableData"
    class="has-text-left"
    default-sort-direction="desc"
    default-sort="date"
    icon-pack="fas"
    per-page="10"
    paginated
    pagination-simple
    narrowed
  >
    <b-table-column field="date" label="Recorded at" sortable v-slot="props">
      <p class="has-text-grey">
        {{ new Date(props.row.date) | formatDate }}
      </p>
    </b-table-column>
    <b-table-column field="bookName" label="Book" sortable v-slot="props">
      {{ props.row.bookName }}
    </b-table-column>
    <b-table-column
      field="sectionNumber"
      label="Section"
      sortable
      v-slot="props"
    >
      <router-link
        :to="getSectionPath(props.row.bookId, props.row.sectionNumber)"
      >
        Section {{ props.row.sectionNumber }}
      </router-link>
    </b-table-column>
  </b-table>
</template>

<script>
import filtersMixin from "@/mixins/filtersMixin";
import routeMixin from "@/mixins/routeMixin";
export default {
  mixins: [filtersMixin, routeMixin],
  props: ["tableData"]
};
</script>

<style lang="scss" scoped></style>
